import { Heading } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'

import {
  Partner as PartnerCardProps,
  PartnersOverview as PartnersOverviewProps,
} from '../../partnerships/types/partnerships-page'
import PartnerCard from './partner-card/partner-card'
import styles from './partners-overview.module.css'

const PartnersOverview: React.FC<PartnersOverviewProps> = (blok) => {
  const partnerCards = blok.partners

  return (
    <section {...storyblokEditable(blok)} className={styles.container}>
      <Heading className={styles.heading}>{blok.heading}</Heading>
      <ul className={styles.listContainer}>
        {partnerCards.map((partner: PartnerCardProps, idx: number) => (
          <PartnerCard {...partner} key={partner._uid} />
        ))}
      </ul>
    </section>
  )
}

export default PartnersOverview
